import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { WatchStopHandle, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { MathUtils } from "three";
import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitView',
  setup(__props) {

const appState = useAppStateStore();
const data = reactive({
	rect: {
		height: 0,
		width: 0,
	},
	isDragging: false,
	splitPercentage: 0.5,
	prevMousePosition: [0, 0],
	minPercentage: 0.05,
	maxPercentage: 0.95,
});

const root = ref<HTMLDivElement>();
const view1Wrapper = ref<HTMLDivElement>();
const view2Wrapper = ref<HTMLDivElement>();
const handle = ref<HTMLDivElement>();
let viewTypeStopHandle: WatchStopHandle | undefined = undefined;

onMounted(() => {
	console.log("Mounted");
	let resizeObserver = new ResizeObserver(() => {
		console.log("The element was resized");
		onSizeChanged();
	});

	viewTypeStopHandle = watch(()=> appState.splitViewType, onSizeChanged); 
	window.addEventListener("pointermove", onMove);
	window.addEventListener("pointerup", onUp);
	resizeObserver.observe(root.value as any);

	onSizeChanged();
});

onUnmounted(() => {
	if(viewTypeStopHandle){
		viewTypeStopHandle();
	}
	window.removeEventListener("pointermove", onMove);
	window.removeEventListener("pointerup", onUp);
});

function onDown(e) {
	e.preventDefault();
	e.stopPropagation();
	data.isDragging = true;
	data.prevMousePosition = [e.clientX, e.clientY];
}

function onUp() {
	data.isDragging = false;
}

function onMove(e) {
	if (data.isDragging) {
		e.preventDefault();
		e.stopPropagation();
		let deltaXPercentage =
			(e.clientX - data.prevMousePosition[0]) / data.rect.width;
		data.splitPercentage = MathUtils.clamp(
			data.splitPercentage + deltaXPercentage,
			data.minPercentage,
			data.maxPercentage
		);
		onSizeChanged();
	}
	data.prevMousePosition[0] = e.clientX;
	data.prevMousePosition[1] = e.clientY;
}

function onSizeChanged() {
	if (!root.value) {
		return;
	}
	data.rect = root.value.getBoundingClientRect();
	let wrapper1 = view1Wrapper.value;
	let wrapper2 = view2Wrapper.value;
	let handleElement = handle.value as any;
	if (wrapper1 && wrapper2 && handleElement) {
		var percentage = appState.splitViewType == "split" ? data.splitPercentage : 0.5;
		wrapper1.style.width = data.rect.width * percentage + "px";
		wrapper1.style.height = data.rect.height + "px";
		wrapper2.style.left = data.rect.width * percentage + "px";
		wrapper2.style.width = data.rect.width * (1 - percentage) + "px";
		wrapper2.style.height = data.rect.height + "px";
		handleElement.style.left = data.rect.width * percentage + "px";

		let slotChildren = [wrapper1.children[0], wrapper2.children[0]] as HTMLElement[];
		for (let i = 0; i < slotChildren.length; i++) {
			var el = slotChildren[i];
			if (el) {
				if (i == 0) {
					el.style.left = "0px";
					el.style.right = "auto";
				} else {
					el.style.left = "auto";
					el.style.right = "0px";
				}

				el.style.width = data.rect.width + "px";
				el.style.height = data.rect.height + "px";
			}
		}
	}
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "split-view"
  }, [
    _createElementVNode("div", {
      ref_key: "view1Wrapper",
      ref: view1Wrapper,
      class: "view-wrapper"
    }, [
      _renderSlot(_ctx.$slots, "view1", { ref: "view1" })
    ], 512),
    _createElementVNode("div", {
      ref_key: "view2Wrapper",
      ref: view2Wrapper,
      class: _normalizeClass(["view-wrapper view2", { 'side-by-side': _unref(appState).splitViewType == 'sideBySide'}])
    }, [
      _renderSlot(_ctx.$slots, "view2", { ref: "view2" })
    ], 2),
    _createElementVNode("div", {
      ref_key: "handle",
      ref: handle,
      class: _normalizeClass(["split-handle", {'hidden' : _unref(appState).splitViewType == 'sideBySide' }])
    }, [
      _createElementVNode("div", {
        onPointerdown: onDown,
        class: "handle-arrows"
      }, null, 32)
    ], 2)
  ], 512))
}
}

})